/// <amd-module name="Build/Run/Components/TestResultsLink" />
import * as React from "react";

import * as Resources from "Build/Run/Resources";
import { IRunDetailsService } from "Build/Run/RunDetailsService.types";
import { TestResults } from "Build/Run/RunExternalService";

import { TestReportDataParser } from "Test/common-util/Common.Utils";

import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

const c_testsGetStartedDoc = "https://go.microsoft.com/fwlink/?linkid=2086578";

interface ITestResultsProps {
    testsTabUrl: string;
    linkDescribedBy?: string;
}

export class TestResultsLink extends VssComponent<ITestResultsProps> {
    private _testsRunResult: IReadonlyObservableValue<TestResults>;

    constructor(props: ITestResultsProps, context: IVssComponentContext) {
        super(props, context);

        const runDetailsService = this.context.pageContext.getService<IRunDetailsService>("IRunDetailsService");
        this._testsRunResult = runDetailsService.testRunResults;
    }

    public render() {
        return <Observer testsResult={this._testsRunResult}>
            {
                (observerProps: { testsResult: TestResults }) => {
                    if (observerProps.testsResult.testsCount > -1) {
                        let text = format(Resources.TestResultsFormat, TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(observerProps.testsResult.testsPassRate, 1));
                        let link = this.props.testsTabUrl;
                        let icon: JSX.Element = <Icon iconName="Completed" className="icon-margin" />;
                        let subtle = true;
                        let className = "text-ellipsis flex-row flex-baseline";

                        // if there are no published tests
                        if (observerProps.testsResult.testsCount === 0) {
                            if (observerProps.testsResult.testsPassRate === -2) {
                                text = Resources.EmptyTestTabText
                            }
                            else {
                                text = Resources.GetStarted;
                                link = c_testsGetStartedDoc;
                                icon = <Icon iconName="TestBeaker" className="icon-margin" />;
                                subtle = false;
                                className += " pipeline-link";
                            }
                        }

                        return <FPSLink ariaDescribedBy={this.props.linkDescribedBy} href={link} className={className} subtle={subtle} removeUnderline={true}>
                            <span className="text-ellipsis">
                                {icon}
                                {text}
                            </span>
                        </FPSLink>
                    }
                    return (
                        <FPSLink ariaDescribedBy="Get started with tests" href={c_testsGetStartedDoc} className="text-ellipsis flex-row flex-baseline pipeline-link" removeUnderline={true}>
                            <span className="text-ellipsis">
                                <Icon iconName="TestBeaker" className="icon-margin" />
                                {Resources.GetStarted}
                            </span>
                        </FPSLink>
                    );
                }
            }
        </Observer>;
    }
}
